var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import { H2, H4 } from "@irati/ui/src/Typography";
import Button from "@irati/ui/src/Button";
import teamService from "@irati/identity/services/teams";
import id from "@irati/utils/id";
import Flex from "@irati/ui/src/Flex";
import { StyledDiv } from "./styled";
import { UserHeader } from "../../Users/User/index";
import AddUserToTeamUserRow from "../AddUserToTeamUserRow/AddUserToTeamUserRow";
import UserListData from "../../../components/UserList";
var AddUsersToTeam = /** @class */ (function (_super) {
    __extends(AddUsersToTeam, _super);
    function AddUsersToTeam() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedEmployees: [],
            submit: null
        };
        _this.toggleSelectedUsers = function (user) {
            _this.setState(function (state) {
                var selectedEmployees = state.selectedEmployees;
                if (selectedEmployees.find(function (test) { return test.uuid === user.uuid; })) {
                    selectedEmployees = selectedEmployees.filter(function (test) { return test.uuid !== user.uuid; });
                }
                else {
                    selectedEmployees = __spreadArrays(selectedEmployees, [user]);
                }
                return {
                    selectedEmployees: selectedEmployees
                };
            });
        };
        _this.handleUserSubmit = function () {
            var submit = Promise.all(_this.state.selectedEmployees.map(function (user) { return teamService.addUserToTeam(_this.props.currentTeam.uuid, user.uuid); })).then(function () {
                _this.props.onSuccess();
            });
            _this.setState({ submit: submit });
            return submit;
        };
        return _this;
    }
    AddUsersToTeam.prototype.render = function () {
        var _this = this;
        var _a = this.state, selectedEmployees = _a.selectedEmployees, submit = _a.submit;
        var currentTeam = this.props.currentTeam;
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(StyledDiv, null,
                            React.createElement(H2, { marginBottom: 4 },
                                React.createElement(FormattedMessage, { id: "admin.components.addUserToTeam.headerTwo.addPeople", values: { currentTeam: currentTeam.public_name } }))))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Flex, { justifyContent: "space-between", alignItems: "center", marginBottom: 2 },
                            React.createElement(H4, null,
                                React.createElement(FormattedMessage, { id: "admin.components.addUserToTeam.headerFour.selectedEmployees", values: { selectedEmployeesLength: selectedEmployees.length } })),
                            React.createElement(Button, { id: id("save-button", this.props), primary: true, className: "pull-right", onClick: this.handleUserSubmit, load: submit },
                                React.createElement(FormattedMessage, { id: "admin.components.addUserToTeam.button.text" }))),
                        React.createElement(UserListData, { ref: this.userList, teamId: null }, function (_a) {
                            var users = _a.users;
                            return (React.createElement(React.Fragment, null,
                                React.createElement(UserHeader, { header: "admin.components.addUserToTeam.userHeader.email" }),
                                users.results.map(function (user) { return (React.createElement(AddUserToTeamUserRow, { key: user.uuid, user: user, selectedEmployees: selectedEmployees, currentTeam: currentTeam, updateSelectedUser: _this.toggleSelectedUsers })); })));
                        }))))));
    };
    AddUsersToTeam.defaultProps = {
        currentTeam: null,
        id: "add-users-to-team"
    };
    return AddUsersToTeam;
}(Component));
export default AddUsersToTeam;
